<template>
    <v-card v-bind="$attrs" v-if="code || show">
      <template v-if="code && code.stamps > 0 && (code.app || !isApp)">
        <v-card-title class="justify-center" v-if="code.name">{{code.name}}</v-card-title>
        <v-card-text v-if="code.description"  v-html="code.description" class="font-weight-light text-center"></v-card-text>
        <center class="pb-3"><v-chip outlined label class="text-h5 mx-auto" v-if="code.code">{{code.code}}</v-chip></center>
      </template>
      <v-card-title class="justify-center" v-else-if="title && code" v-text="title" style="text-align: center;"></v-card-title>
  <center>
     <a class="btn btn-google btn-apple" href="https://apps.apple.com/nl/app/eetplein/id1574463354" target="_blank" title="Google Play">
       <svg class="btn__icon btn__icon--apple" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 20 20">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5640259,13.8623047
        c-0.4133301,0.9155273-0.6115723,1.3251343-1.1437988,2.1346436c-0.7424927,1.1303711-1.7894897,2.5380249-3.086853,2.5500488
        c-1.1524048,0.0109253-1.4483032-0.749939-3.0129395-0.741333c-1.5640259,0.008606-1.8909302,0.755127-3.0438843,0.7442017
        c-1.296814-0.0120239-2.2891235-1.2833252-3.0321655-2.4136963c-2.0770874-3.1607666-2.2941895-6.8709106-1.0131836-8.8428955
        c0.9106445-1.4013062,2.3466187-2.2217407,3.6970215-2.2217407c1.375,0,2.239502,0.7539673,3.3761597,0.7539673
        c1.1028442,0,1.7749023-0.755127,3.3641357-0.755127c1.201416,0,2.4744263,0.6542969,3.3816528,1.7846069
        C14.0778809,8.4837646,14.5608521,12.7279663,17.5640259,13.8623047z M12.4625244,3.8076782
        c0.5775146-0.741333,1.0163574-1.7880859,0.8571167-2.857666c-0.9436035,0.0653076-2.0470581,0.6651611-2.6912842,1.4477539	C10.0437012,3.107605,9.56073,4.1605835,9.7486572,5.1849365C10.7787476,5.2164917,11.8443604,4.6011963,12.4625244,3.8076782z"/>
            </svg>   
        App Store</a>
      <a class="btn btn-google" href="https://play.google.com/store/apps/details?id=mijn.eetplein.nl" target="_blank" title="Google Play">Google Play</a>
    </center>
  </v-card>
  <v-alert dismissable v-bind="$attrs" v-else-if="isApp">
     <v-list-item >
           <v-list-item-avatar class="mr-2">
           <v-img src="/img/eetplein.png"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Eetplein</v-list-item-title>
              <v-list-item-subtitle v-if="host" v-text="host.name"></v-list-item-subtitle>
              <v-list-item-subtitle v-else>Officiële {{appname}}</v-list-item-subtitle>
              
              </v-list-item-content>
          </v-list-item>
          <center><v-chip label outlined v-if="host && host.actioncode" class="mx-auto font-weight-bold" v-text="host.actioncode"></v-chip></center>
          <v-card-text>
            Onze {{appname}} staat klaar in de {{storename}}, Download hem vandaag nog. <span v-if="host && host.actioncode">Gebruik bovenstaande code en krijg gelijk 5 volle stempelkaarten voor gratis extra's.</span>
          </v-card-text>
    <v-card-actions>
      <v-btn text @click="showMessage=false">Sluiten</v-btn>
      <v-spacer></v-spacer>
      
     
      <a class="btn btn-google btn-apple" v-if="isIos || showAll" href="https://apps.apple.com/nl/app/eetplein/id1574463354" target="_blank" title="Google Play">
       <svg class="btn__icon btn__icon--apple" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 20 20">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5640259,13.8623047
        c-0.4133301,0.9155273-0.6115723,1.3251343-1.1437988,2.1346436c-0.7424927,1.1303711-1.7894897,2.5380249-3.086853,2.5500488
        c-1.1524048,0.0109253-1.4483032-0.749939-3.0129395-0.741333c-1.5640259,0.008606-1.8909302,0.755127-3.0438843,0.7442017
        c-1.296814-0.0120239-2.2891235-1.2833252-3.0321655-2.4136963c-2.0770874-3.1607666-2.2941895-6.8709106-1.0131836-8.8428955
        c0.9106445-1.4013062,2.3466187-2.2217407,3.6970215-2.2217407c1.375,0,2.239502,0.7539673,3.3761597,0.7539673
        c1.1028442,0,1.7749023-0.755127,3.3641357-0.755127c1.201416,0,2.4744263,0.6542969,3.3816528,1.7846069
        C14.0778809,8.4837646,14.5608521,12.7279663,17.5640259,13.8623047z M12.4625244,3.8076782
        c0.5775146-0.741333,1.0163574-1.7880859,0.8571167-2.857666c-0.9436035,0.0653076-2.0470581,0.6651611-2.6912842,1.4477539	C10.0437012,3.107605,9.56073,4.1605835,9.7486572,5.1849365C10.7787476,5.2164917,11.8443604,4.6011963,12.4625244,3.8076782z"/>
            </svg>   
        App Store</a>
      <a class="btn btn-google" v-if="isAndroid || showAll" href="https://play.google.com/store/apps/details?id=mijn.eetplein.nl" target="_blank" title="Google Play">Google Play</a>
    </v-card-actions>
    
  </v-alert>
</template>
<script>
export default {
  name: "v-store",
  props: {
    host: {
      type: Object,
      default: function() {
        return null;
      }
    },
    order: {
      type: Object,
      default: function() {
        return null;
      }
    },
    showAll: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    show: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    code: {
      type: Object,
      default: function() {
        return null;
      }
    },
    title: {
      type: String,
      default: 'Download nu onze nieuwe app!'
    },
  
    
  },
  data: () => ({
    
  }),
  computed: {
    isIos(){
     // if (this.isLocalHost && !this.$vuetify.breakpoint.mobile) return true
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test( userAgent );
    },
    isAndroid(){
     // if (this.isLocalHost && !this.$vuetify.breakpoint.mobile) return true
      const userAgent = window.navigator.userAgent.toLowerCase();
      console.log(userAgent)
      return /android/.test( userAgent );
    },
    isApp() {
          return window.matchMedia('(display-mode: standalone)').matches ? true: false
      },
    storename(){
      if (this.isAndroid) return 'Playstore'
      if (this.isIos) return 'Apple store'
      return 'online stores'
    },
    appname(){
      if (this.isAndroid) return 'Android app'
      if (this.isIos) return 'iPhone app'
      return 'app'
    },
    
  },
  mounted(){
    //this.showMessage =  this.order  && this.order.source == 'thuisbezorgd' && this.host && this.host.actioncode && this.isAndroid
  },
  methods: {
   
  }
};
</script>
<style>
.v-application a.btn-google{color:#fff;fill: #fff;}
.btn{padding:10px 16px;margin:5px;font-size:18px;line-height:1.3333333;border-radius:6px;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;font-weight:500;text-decoration:none;display:inline-block}
.btn:active:focus,.btn:focus{outline:0}
.btn:focus,.btn:hover{color:#333;text-decoration:none;outline:0}
.btn:active{outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}
.btn-google{color:#fff;background-color:#111;border-color:#000;padding:15px 16px 5px 40px;position:relative;font-weight:600}
.btn-google:focus{color:#fff;background-color:#555;border-color:#000}
.btn-google:active,.btn-google:hover{color:#fff;background-color:#555;border-color:#000;}
.btn-google:not(.btn-apple):before{content:"";background-image:url(https://4.bp.blogspot.com/-52U3eP2JDM4/WSkIT1vbUxI/AAAAAAAArQA/iF1BeARv2To-2FGQU7V6UbNPivuv_lccACLcB/s30/nexus2cee_ic_launcher_play_store_new-1.png);background-size:cover;background-repeat:no-repeat;width:30px;height:30px;position:absolute;left:6px;top:50%;margin-top:-15px}
.btn-google:not(.btn-apple):after{content:"Get it on";position:absolute;top:5px;left:40px;font-size:10px;font-weight:400;}
.btn-google.btn-apple:after{content:"Download on the";position:absolute;top:5px;left:40px;font-size:10px;font-weight:400;}
.btn__icon{
    position: absolute;
    width: 35px;
    margin-left: -37px;
    margin-top: -12px;
}

</style>